import styled from "styled-components/macro";
import { theme } from "../../styles/theme";

export const Wrapper = styled.div`
  display: flex;
  max-width: 1360px;
  width: 100%;
  margin: 64px auto;
  justify-content: center;
  & > div {
    padding: 0 80px;
    width: 100%;
    display: flex;
    flex-direction: column;
    @media (max-width: 910px) {
      padding: 0 40px;
    }
    @media (max-width: 820px) {
      padding: 0 20px;
    }
  }
`;

export const Title = styled.div`
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 24px;
  color: ${theme.colors.text}; 
  align-self: center;
  & span {
    color: ${theme.colors.primary};
  }
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 475px) {
    font-size: 32px;
  }
  @media (max-width: 375px) {
    font-size: 28px;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const CardWrapper = styled.div`
    max-width: 310px;
    width: 100%;
    margin: 0 10px;
    & div {
      align-self: flex-start;
      color: ${theme.colors.text};
      font-size: 20px;
      margin-bottom: 8px;
    }
    & p {
      color: ${theme.colors.textDimmed};
      font-size: 18px;
    }
    & img, svg {
      margin-bottom: 24px;
    }
    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      max-width: 100%;
    }
`;